import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If the markup was pre-rendered (postbuild prerender step), hydrate it so
// crawlers get full HTML on first crawl while users keep full interactivity.
// Otherwise fall back to a normal client-side render.
if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
